import {
	CargoActionFromCallSideviewer,
	CargoFromCallSideviewer,
} from "view/calls/components/sideviewer/useCallSideviewer";
import VoyageCargoActionTimesheet from "view/voyages/components/timesheet/VoyageCargoActionTimesheet";

const CallSideviewerTimesheetBlock = (
	{
		cargo,
		selectedAction,
		refetch,
		forceReadOnly,
	}: {
		cargo: CargoFromCallSideviewer | null;
		selectedAction: CargoActionFromCallSideviewer | null;
		refetch: () => void;
		forceReadOnly?: boolean;
	}) => {

	if (!selectedAction || !cargo) {
		return null;
	}

	return selectedAction && <VoyageCargoActionTimesheet
		collapsable
		cargoAction={selectedAction}
		refetch={refetch}
		asOverrideSkipperTimes={false}
		forceReadOnly={forceReadOnly}
	/>;
};

export default CallSideviewerTimesheetBlock;
